module.exports = __webpack_public_path__ + "img/auflauf-1.165754ab.jpg";